const initialState = {
  resultsPermissionsList: [],
  resultsPermission: {},
  resultsPermissionAdd: {},
  resultsPermissionEdit: {},
  resultsPermissionDelete: {}
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "LIST_PERMISSION_RESPONSE_GET":
      newState.resultsPermissionsList = action.value;
      break;
    case "PERMISSION_RESPONSE_GET":
      newState.resultsPermission = action.value;
      break;
    case "PERMISSION_RESPONSE_RESET":
      newState.resultsPermission = {};
      break;
    case "PERMISSION_RESPONSE_ADD":
      newState.resultsPermissionAdd = action.value;
      break;
    case "PERMISSION_RESPONSE_EDIT":
      newState.resultsPermissionEdit = action.value;
      break;
    case "PERMISSION_RESPONSE_DELETE":
      newState.resultsPermissionDelete = action.value;
      break;
    default:
      break;
  }
  return newState;
}

export default reducer;
